<script>
	import UISection from "../ui/UISection.svelte";
	import UIBreadcrumb from "../ui/UIBreadcrumb.svelte";
	import UIList from "../ui/UIList.svelte";
	import UIListItem from "../ui/UIListItem.svelte";
	import UITitle from "../ui/UITitle.svelte";
	import UIButton from "../ui/UIButton.svelte";
	import UISubcategoryList from "../ui/UISubcategoryList.svelte";
	import UICover from "../ui/UICover.svelte";
	import UICategory from "../ui/UICategory.svelte";
	import base from "../stores/base";
	import router from "../stores/router";

	const unit = 12;

	let category = "";
	let title = "";
	let subcategories = [];
	let items = [];

	if (!$base.categories[$router.params.category]) {
		router.push("/404");
	} else {
		fetch(process.env.APP_API + "/items/index")
			.then((res) => {
				return res.json();
			})
			.then((json) => {
				if (json.message) {
					console.log("----", json.message);
					router.push("/404");
				} else {
					items = json;
				}
			})
			.catch((e) => {
				console.log("----error", e);
				router.push("/404");
			});
	}

	$: {
		category = $router.params.category;
		if ($base.categories[category]) {
			title = $base.categories[category][$base.lang];
			router.track(title);
			if($base.categories[category].subcategories){
				subcategories = $base.categories[category].subcategories;
			}else {
				subcategories = []
			}
		}
	}
	$: viewCount = Math.min(filteredItems.length, unit);

	$: filteredItems =
		category === "news"
		// 全ての記事がある場合
		// category === "all"
			? items.filter((item) => item.category !== "active_programs" && item.category !== "dementia_programs")
			: $base.categories[category].subcategories ? items.filter((item) => $base.categories[category].subcategories.includes(item.category)) : items.filter((item) => item.category === category);

	$: dispItems = filteredItems.slice(0, viewCount);

	function onClickMore() {
		viewCount = Math.min(filteredItems.length, viewCount + unit);
	}
</script>

<main>
	<UICover small image={$base.allCover}>
		<UITitle>{title}</UITitle>
		<UICategory />
	</UICover>

	<UISection gray paddingtop="3em">
		{#if subcategories.length > 0}
			<UISubcategoryList {subcategories}/>
		{/if}
		<UIList>
			{#each dispItems as data}
				<UIListItem {data} />
			{/each}
		</UIList>
	</UISection>
	<UISection center gray paddingtop="0.5em;" paddingbottom="4em">
		{#if filteredItems.length > viewCount}
			<UIButton icon="plus" on:click={onClickMore}
				>{{ ja: "もっと見る", en: "See More" }[$base.lang]}
				<small
					>{{ ja: "残り", en: " (" }[
						$base.lang
					]}{filteredItems.length - viewCount}{{
						ja: "件",
						en: "items)",
					}[$base.lang]}</small
				></UIButton
			>
		{/if}
	</UISection>
	<UIBreadcrumb bottom />
</main>
